/** Spanish. Keys are the English text; see i18n.ts. To be reviewed by a native speaker before release. */
export const es: Record<string, string> = {
  // top bar and menus
  Mailbox: 'Buzón',
  Notifications: 'Notificaciones',
  'New order': 'Nueva orden',
  View: 'Ver',
  Account: 'Cuenta',
  Settings: 'Configuración',
  'Keyboard shortcuts': 'Atajos de teclado',
  'Welcome guide': 'Guía de bienvenida',
  'Install as an app': 'Instalar como aplicación',
  'Sign out': 'Cerrar sesión',
  'New chart': 'Nuevo gráfico',
  'Compact layout': 'Diseño compacto',
  'Profiles…': 'Perfiles…',
  'Reset layout': 'Restablecer diseño',
  // panels
  'Market Watch': 'Observación del mercado',
  Trade: 'Operaciones',
  History: 'Historial',
  'New Order': 'Nueva orden',
  Challenge: 'Desafío',
  Alerts: 'Alertas',
  'Tick chart': 'Gráfico de ticks',
  'Data Window': 'Ventana de datos',
  // settings
  Appearance: 'Apariencia',
  'Time and numbers': 'Hora y números',
  Trading: 'Trading',
  Done: 'Listo',
  Language: 'Idioma',
  // sign-in
  'Sign in': 'Iniciar sesión',
  'Trade, chart and manage your account.': 'Opere, analice gráficos y gestione su cuenta.',
  'Account number': 'Número de cuenta',
  Email: 'Correo electrónico',
  Password: 'Contraseña',
  'Remember my account number on this device': 'Recordar mi número de cuenta en este dispositivo',
  'Signing in…': 'Iniciando sesión…',
  'Forgot your password?': '¿Olvidó su contraseña?',
  'New here?': '¿Es nuevo?',
  'Open a demo account': 'Abrir una cuenta demo',
  'Investor sign-in': 'Acceso de inversor',
  'Investor password': 'Contraseña de inversor',
  'View the account': 'Ver la cuenta',
  'View this account with its investor password. You can look, but not trade or change anything.':
    'Vea la cuenta con su contraseña de inversor. Puede consultarla, pero no operar ni cambiar nada.',
  'Use the investor (read-only) password': 'Usar la contraseña de inversor (solo lectura)',
  'Use my own password instead': 'Usar mi propia contraseña',
  'Email me a link': 'Enviarme un enlace',
  'Back to sign in': 'Volver a iniciar sesión',
  'Choose a new password': 'Elija una nueva contraseña',
  'New password': 'Nueva contraseña',
  'Repeat the new password': 'Repita la nueva contraseña',
  'Set the new password': 'Guardar la nueva contraseña',
};
